<template>
  <EntitySingle :config="config" :entity.sync="entity" :loaded.sync="entityLoaded">
    <b-card v-if="entityLoaded">
      <b-tabs pills>
        <!-- Tab: Account -->
        <b-tab active>
          <template #title>
            <feather-icon icon="UserIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">{{ $t('Account') }}</span>
          </template>
          <EntityEditSection
            :module="config.module"
            :entity.sync="entity"
            :form-fields="accountFormFields"
            allow-autofocus
          />
        </b-tab>

        <!-- Tab: Information -->
        <b-tab>
          <template #title>
            <feather-icon icon="InfoIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">{{ $t('Information') }}</span>
          </template>
          <EntityEditSection
            :module="config.module"
            :entity.sync="entity"
            :form-fields="personalFormFields"
          />
        </b-tab>
      </b-tabs>
    </b-card>
  </EntitySingle>
</template>

<script>
import { BTab, BTabs, BCard } from 'bootstrap-vue'
import { translationUtils } from '@core/mixins/ui/translations'
import EntityEditSection from '@/layouts/entity/EntityEditSection.vue'
import EntitySingle from '@/layouts/entity/EntitySingle.vue'

import storeModule from '../customersStoreModule'
// import UserEditTabInformation from './UserEditTabInformation.vue'
// import UserEditTabSocial from './UserEditTabSocial.vue'

export default {
  components: {
    EntityEditSection,
    EntitySingle,
    BTab,
    BTabs,
    BCard,
    // UserEditTabInformation,
    // UserEditTabSocial,
  },
  mixins: [translationUtils],
  data() {
    return {
      entity: {
        participant: {},
      },
      entityLoaded: false,
      countryOptions: [],
      companyOptions: [],
    }
  },
  computed: {
    config() {
      return {
        store: storeModule,
        module: 'customer',
        endpoint: 'customer',
        route: 'customers',
        title: {
          single: this.$t('Customer'),
          plural: this.$t('Customers'),
        },
      }
    },

    accountFormFields() {
      const formFields = [
        {
          id: 'firstName',
          parent: 'participant',
          type: 'text',
          label: this.$t('First Name'),
          required: true,
          rules: 'min:3',
          colSize: 3,
        },
        {
          id: 'lastName',
          parent: 'participant',
          type: 'text',
          label: this.$t('Last Name'),
          required: true,
          rules: 'min:3',
          colSize: 3,
        },
        {
          id: 'companies',
          type: 'selectmultiple',
          label: this.$t('Companies'),
          options: this.companyOptions,
          colSize: 6,
        },
        {
          id: 'email',
          parent: 'participant',
          type: 'email',
          label: this.$t('email'),
          required: true,
          rules: 'email',
          colSize: 3,
        },
        {
          id: 'enabled',
          type: 'checkbox',
          label: this.$t('Enabled'),
          colSize: 2,
        },
      ]
      return formFields
    },
    personalFormFields() {
      return [
        {
          id: 'country',
          object: true,
          parent: 'participant',
          type: 'select',
          label: this.$t('country'),
          options: this.countryOptions,
          required: true,
          colSize: 3,
        },
        {
          id: 'city',
          parent: 'participant',
          type: 'text',
          label: this.$t('city'),
          required: false,
          colSize: 3,
        },
        {
          id: 'address',
          parent: 'participant',
          type: 'text',
          label: this.$t('address'),
          required: false,
          colSize: 3,
        },
        {
          id: 'postalCode',
          parent: 'participant',
          type: 'text',
          label: this.$t('postal code'),
          required: false,
          colSize: 3,
        },
        {
          id: 'telephone',
          parent: 'participant',
          type: 'text',
          label: this.$t('telephone'),
          rules: 'phone',
          colSize: 3,
        },
        {
          id: 'mobile',
          parent: 'participant',
          type: 'text',
          label: this.$t('mobile'),
          rules: 'phone',
          colSize: 3,
        },
        {
          id: 'birthDate',
          parent: 'participant',
          type: 'date',
          label: this.$t('birth date'),
          colSize: 3,
        },
        {
          id: 'companyName',
          parent: 'participant',
          type: 'text',
          label: this.$t('company name'),
          colSize: 3,
        },
        {
          id: 'vatId',
          parent: 'participant',
          type: 'text',
          label: this.$t('vat'),
          required: false,
          colSize: 3,
        },
        {
          id: 'vatOffice',
          parent: 'participant',
          type: 'text',
          label: this.$t('vat office'),
          required: false,
          colSize: 3,
        },
        {
          id: 'professionalTitle',
          parent: 'participant',
          type: 'text',
          label: this.$t('professional title'),
          required: false,
          colSize: 3,
        },
        {
          id: 'bio',
          parent: 'participant',
          type: 'text',
          label: this.$t('bio'),
          required: false,
          colSize: 3,
        },
        {
          id: 'map',
          type: 'map',
          colSize: 12,
        },
      ]
    },
  },
  mounted() {
    this.$store.dispatch('app-common/fetchCountries').then(response => {
      this.countryOptions = response.data
    })
    this.$store.dispatch('app-common/fetchCompanies').then(response => {
      this.companyOptions = response.data
    })
  },
}
</script>
